import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'moreThan',
    standalone: true
})
export class MoreThanPipe implements PipeTransform {
    transform(value: number | string, limit: number = 99): string {
        if (typeof value === 'string') value = parseInt(value);
        return value > limit ? `${limit}+` : `${value}`;
    }
}
